import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTags} from "@fortawesome/free-solid-svg-icons/faTags";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";

import {FieldPickerTextBoxPlugin} from "PageBuilder/pagebuilder/Controls/FieldPickerTextBox/FieldPickerTextBoxPlugin";
import {FieldPickerTextBoxSlateRenderer} from "PageBuilder/pagebuilder/Controls/FieldPickerTextBox/FieldPickerTextBoxSlateRenderer";
import {CSSProperties} from "react";
import {EventManager} from "shared/utilities/Events/EventManager";

import { List } from "immutable";
import {RenderMark} from "PageBuilder/Events/RenderMark";
import { Editor } from "slate-react";
import {Inline, Operation, Value} from "slate";
import './FieldPickerTextBox.css';
import {ServerItemFieldPicker} from "PageBuilder/pagebuilder/Controls/FieldPickerTextBox/ServerItemFieldPicker";

export class FieldPickerTextBox extends React.Component<FieldPickerTextBoxProps, FieldPickerTextBoxState> {
    static defaultProps: Partial<FieldPickerTextBoxProps> = {
        OnChange:null
    };
    instance:any;
    public AvailableOptions:any[];
    public editor:Editor;
    public ObjectsToLoad=null;
    public Plugins:any;
    public Schemas:any;
    constructor(props: FieldPickerTextBoxProps) {
        super(props);
        this.state = {
            Value:this.PrepareContent(props)
        };
        this.Plugins=[FieldPickerTextBoxPlugin]
        this.RenderEditor=this.RenderEditor.bind(this);
        this.Schemas={};
        this.Schemas.blocks={};
        this.Schemas.document={
            nodes: [
                {
                    match: { type: 'paragraph' },
                    min: 1,
                    max: 1
                },
            ]

        };
        this.Schemas.inlines={};
        this.Schemas.inlines.field={isVoid:true};

    }

    private PrepareContent(props: FieldPickerTextBoxProps) {
        if(props.Content[this.props.PropertyName]==null)
            props.Content[props.PropertyName]={
                document: {
                    nodes: [
                        {
                            object: 'block',
                            type: 'paragraph',
                            nodes: [
                                {
                                    object: 'text',
                                    leaves: [
                                        {
                                            text: '',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            };
        this.ObjectsToLoad=Value.fromJSON(props.Content[this.props.PropertyName] as any);
        return    Value.fromJSON({
            document: {
                nodes: [
                    {
                        object: 'block',
                        type: 'paragraph',
                        nodes: [
                            {
                                object: 'text',
                                leaves: [
                                    {
                                        text: 'aaafff',
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        }as any);

    }

    public RenderEditor(node:any)
    {
        this.editor=node;

        if(this.editor!=null)
        {
            this.setState( {
                Value: this.ObjectsToLoad
            } )as any
        }
    }




    public render() {
        return (
            <div className={'rncontrol'}>
                <div>
                    <label style={{width:'100%',display:'block'}}>{this.props.label}</label>
                </div>
                <div style={{position:'relative'}}>
                    <Editor schema={this.Schemas}  className={'fieldPickerTextBox'}
                            renderNode={(props,editor,next)=>this.RenderNode(props,editor,next)}
                            ref={this.RenderEditor} value={this.state.Value}
                            onChange={e=>{this.Change(e);this.props.OnChange&&this.props.OnChange()}}   plugins={this.Plugins}  />
                    <div className={'rnTagIcon'} style={{position:'absolute',right:3,top:'50%',marginTop:-8,fontSize:16,cursor:'pointer'}} onClick={()=>this.OpenDialog()}>
                        <FontAwesomeIcon icon={faTags} />
                    </div>
                </div>
            </div>
        )
    }
    private Change(e: { operations: List<Operation>; value: Value }) {

        if(this.state.Value.document!=e.value.document) {
            this.props.Content[this.props.PropertyName] = e.value.toJSON();
        }
        this.setState({Value:e.value});


    }

    renderMark (props, editor, next) {
        const { children, mark, attributes } = props

        let markElement= EventManager.Publish(new RenderMark(children,mark,attributes));
        if(markElement==null)
            return next();

        return markElement;
    }

    private RenderNode(props: any, editor: any, next: () => any) {
        const { attributes, children, node } = props;

        if(props.node.type=='paragraph') {
            let styles:CSSProperties={};


            return <span {...attributes} style={styles}>{children}</span>
        }


        if(props.node.type=='field')
        {
            return <FieldPickerTextBoxSlateRenderer Node={props.node} Editor={editor} SlateProps={props} Model={this.props.Model.Fields}/>
        }


        return next();
    }




    private async OpenDialog() {

        let fields=this.props.Model.Fields;

        let fieldDialog=await Dialog.Show(<ServerItemFieldPicker Fields={fields}/>);


        if(fieldDialog==null)
            return;

        let block=Inline.create(
            {
                type:"field",
                data:{
                    SubType:fieldDialog.Type,
                    FieldId:fieldDialog.Value,
                    IncludeLabel:false,
                }
            }
        );
        let node=this.editor.insertInline(block);

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FieldPickerTextBoxProps {
    label:string;
    Content:any;
    PropertyName:string;
    Model:FormDTO;
    OnChange:()=>void;
}

interface FieldPickerTextBoxState {
    Value:Value;

}

//#endregion "My Region"